import styled from 'styled-components'
import { COLORS } from '../../constants'

/* eslint-disable no-undef */

export const Container = styled.div`
  width: 100%;
  height: 10rem;
  min-height: 10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.primary};
  margin: 0 0 1rem 0;
  padding: 1rem 0;
`

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: ${COLORS.gray};
  margin-bottom: 2rem;
`

export const IndicatorLabels = styled.div`
  display: flex;
  width: 20rem;
  position: relative;
  margin-bottom: 0.75rem;
  margin-left: 4rem;
  height: 1.5rem;

  @media (max-width: 768px) {
    width: 18rem;
    margin-left: 3rem;
  }

  @media (max-width: 480px) {
    width: 16rem;
    margin-left: 2rem;
    height: 1.25rem;
  }
`

export const IndicatorLabel = styled.span<{ $position: string }>`
  position: absolute;
  left: ${({ $position }) => $position};
  transform: translateX(-50%);
  font-size: 0.875rem;
  color: #22c55e;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  top: 0;
  z-index: 10;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }

  @media (max-width: 480px) {
    font-size: 0.625rem;
  }

  /* Adjust positioning for smaller screens to prevent overlap */
  @media (max-width: 600px) {
    &:first-child {
      left: 25% !important;
      transform: translateX(-50%);
    }
    &:last-child {
      left: 75% !important;
      transform: translateX(-50%);
    }
  }
`

export const WrapperContainerBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  margin-left: 4rem;
`

export const BarContainer = styled.div`
  position: relative;
  width: 20rem;
`

export const ContainerBar = styled.div`
  justify-content: center;
  width: 20rem;
  height: 2rem;
  background-color: ${COLORS.gray};
  overflow: hidden;
  border-radius: 8px;
`

export const IndicatorLines = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`

export const IndicatorLine = styled.div<{ $position: string }>`
  position: absolute;
  left: ${({ $position }) => $position};
  top: -4px;
  width: 2px;
  height: calc(100% + 8px);
  background-color: #22c55e;
  transform: translateX(-50%);
  border-radius: 1px;
`

export const RangeIndicator = styled.div<{ $start: string; $width: string }>`
  position: absolute;
  left: ${({ $start }) => $start};
  top: 0;
  width: ${({ $width }) => $width};
  height: 100%;
  background-color: #22c55e;
  border-radius: 0;
  opacity: 0.6;
`

export const Fill = styled.div<{ $percentage: number; $color: string }>`
  height: 100%;
  background-color: ${({ $color }) => $color};
  width: ${({ $percentage }) => $percentage}%;
`

export const Message = styled.p`
  font-size: 1.5rem;
  color: ${COLORS.gray};
`
export const CurrentLoad = styled.p`
  font-size: 1.2rem;
  color: ${COLORS.gray};
  margin-left: 1rem;
`
